'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".Action-module_container__d5jon{align-items:center;background:red;border-radius:2.5rem;color:#fff;cursor:pointer;display:flex;height:1.75rem;margin:0 .5rem;padding:.375rem .6875rem}@media only screen and (min-width:48rem){.Action-module_container__d5jon{padding:.375rem 1rem}}.Action-module_icon__7G6zE{align-items:center;display:flex}.Action-module_text__khwOj{display:none;margin:0 0 0 .75rem}@media only screen and (min-width:48rem){.Action-module_text__khwOj{display:block}}";
var styles = {"container":"Action-module_container__d5jon","icon":"Action-module_icon__7G6zE","text":"Action-module_text__khwOj"};
styleInject["default"](css_248z, 'b7802d57-f771-4960-bca7-7d50f06cbf32');

exports["default"] = styles;
